(function() {
    function okeWidgetControlInit() {
        var snippetEl = document.querySelector('#orc-widget-snippet');
        var controlEl = document.querySelector('#orc-collection-control');
        var collectionRadioElements = Array.prototype.slice.call(document.querySelectorAll('.js-orc-collectionRadio'));
        controlEl.style.display = 'block';

        collectionRadioElements.forEach(function(radioElement) {
            radioElement.addEventListener('change', function() {
                snippetEl.okeReviews.setCollection(radioElement.value);
                collectionRadioElements.forEach(function(element) {
                element.classList.remove('orc-collectionControls-item-input--checked');
                });
                radioElement.classList.add('orc-collectionControls-item-input--checked');
            });
        });
    }

    window.okeReviewsWidgetOnInit = okeWidgetControlInit;
})();